"use client";
import Image from "next/image";

export default function NotFound() {
  return (
    <>
      <div className="flex items-center justify-between bg-white px-2 "></div>
      <main className="flex  h-screen flex-1 flex-col items-center justify-center gap-12 bg-white px-6 ">
        <div className="w-full max-w-2xl text-center">
          {/* Playful 404 illustration */}
          <div className="relative mb-12 inline-block">
            <Image
              width={200}
              height={200}
              src="/404p.jpg"
              alt="404 illustration"
              className="h-64 w-64 rounded-3xl object-cover mix-blend-multiply transition-transform duration-300  sm:h-80 sm:w-80"
            />
            <div className="pointer-events-none absolute inset-0 rounded-3xl bg-[radial-gradient(ellipse_at_center,rgba(255,255,255,0)_60%,rgba(255,255,255,0.85)_85%,rgba(255,255,255,1)_100%)]" />

            {/* Playful floating badge */}
            <div className="absolute -right-4 -top-4 flex h-20 w-20 rotate-12 transform items-center justify-center rounded-full bg-indigo-600 text-2xl font-bold text-white shadow-lg transition-transform duration-300 hover:rotate-0">
              404
            </div>
          </div>

          {/* Clean typography */}
          <h1 className="mb-4 text-5xl font-bold text-gray-900 sm:text-6xl">
            Oops! Lost in space
          </h1>

          <p className="mx-auto mb-12 max-w-md text-lg text-gray-600">
            The page you're looking for seems to have wandered off. Let's get
            you back home!
          </p>

          {/* Simple, clean buttons */}
          <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
            <a
              href="/"
              className=" flex items-center gap-1 rounded-full bg-indigo-600 px-8 py-3 font-medium text-white shadow-sm transition-colors duration-200 hover:bg-indigo-700 hover:shadow-md"
            >
              <svg
                height="20"
                width="20"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.53 6.47a.75.75 0 0 1 0 1.06l-3.72 3.72H18a.75.75 0 0 1 0 1.5H7.81l3.72 3.72a.75.75 0 1 1-1.06 1.06l-5-5a.75.75 0 0 1 0-1.06l5-5a.75.75 0 0 1 1.06 0"
                  fill="currentColor"
                />
              </svg>{" "}
              Take me home
            </a>
          </div>
        </div>
      </main>
    </>
  );
}
